// extracted by css-extract-rspack-plugin
export default {"container":"GlG89","header":"IvY2K","title":"pudiQ","viz":"Wnivo"};